import { styled } from '@mui/material';
import { chipClasses, ChipProps, default as MuiChip } from '@mui/material/Chip';

const Chip = styled((props: ChipProps) => <MuiChip {...props} />)(
  ({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    fontWeight: 400,
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,

    [`&.${chipClasses.colorDefault}`]: {
      color: theme.palette.grey[900],
    },
    [`&.${chipClasses.filled}.${chipClasses.colorDefault}`]: {
      backgroundColor: theme.palette.primary[50],
    },
    [`&.${chipClasses.outlined}.${chipClasses.colorDefault}`]: {
      border: `1px solid ${theme.palette.primary[200]}`,
    },
    [`&.${chipClasses.colorDefault} .${chipClasses.deleteIcon}`]: {
      color: theme.palette.primary[300],
    },
    [`&.${chipClasses.colorDefault} .${chipClasses.deleteIcon}:hover`]: {
      color: theme.palette.primary[400],
    },
  })
);

export default Chip;
